import themeActionTypes from "./theme.types";

export const setTheme = (theme) => ({
  type: themeActionTypes.SET_THEME,
  payload: theme,
});